/**
 * Generate a UUID that works in both secure (HTTPS) and non-secure (HTTP) contexts
 * Uses crypto.randomUUID() when available, otherwise falls back to a polyfill
 */
export function generateUUID(): string {
  // Try to use native crypto.randomUUID if available (HTTPS context)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    try {
      return crypto.randomUUID();
    } catch {
      // Fall through to polyfill
    }
  }

  // Fallback polyfill for HTTP contexts or older browsers
  // Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
